<script lang="ts">
	import type { SearchCarResult } from '../search/cars/types';
	import { GetDefaultCarOptionsStore, UpdateRegisteredCarStore } from '$houdini';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import { isMobile } from '$lib/services/mediaQuery/screenSize';
	import { trackSaveCar } from '$lib/services/tracking/googleAnalytics/car';
	import * as m from '$paraglide/messages';
	import { onMount } from 'svelte';
	import CarForm from '../itinerary/options/cars/CarForm/CarForm.svelte';
	import ModalDialog from '../modals/ModalDialog.svelte';
	import { addNotification } from '../notifications/notifications';

	interface Props {
		open: boolean;
		onSaveCar?: () => void;
	}

	let { open = $bindable(), onSaveCar }: Props = $props();

	let saveCarQueryStore: UpdateRegisteredCarStore;
	let getDefaultCarOptionsQueryStore: GetDefaultCarOptionsStore;

	let selectedCar: SearchCarResult | null = $state(null);
	let userCarId: string | undefined = $state(undefined);
	let saveCarError = $state(false);
	let initialStateLoading = $state(true);

	function saveCar(carId: string | undefined) {
		if (!saveCarQueryStore) {
			saveCarQueryStore = new UpdateRegisteredCarStore();
		}

		if (!carId) {
			return;
		}

		saveCarError = false;
		saveCarQueryStore
			.mutate({
				input: {
					carId,
				},
			})
			.then(() => {
				addNotification(m.register_car__register_success());
				open = false;
				onSaveCar?.();
			})
			.catch(() => {
				saveCarError = true;
				addNotification(m.register_car__register_error());
			});
	}

	function fetchDefaultCarOptions() {
		if (!getDefaultCarOptionsQueryStore) {
			getDefaultCarOptionsQueryStore = new GetDefaultCarOptionsStore();
		}

		getDefaultCarOptionsQueryStore
			.fetch({
				policy: 'NetworkOnly',
			})
			.then((result) => {
				const defaultCarOptionsResult = result.data?.getDefaultCarOptions;
				if (!defaultCarOptionsResult?.car) {
					return;
				}
				const { car, userCarId: carId } = defaultCarOptionsResult;

				selectedCar = car;
				userCarId = carId ?? undefined;
			})
			.finally(() => {
				initialStateLoading = false;
			});
	}

	onMount(() => {
		fetchDefaultCarOptions();
	});
</script>

<ModalDialog
	bind:open
	centered
	contentDialogClasses="bg-neutral-weakest md:p-4 md:rd-2 w-full h-full md:w-100 md:h-auto"
	hideCloseButton={$isMobile}
	closeText=""
>
	<div class="w-full p-2 md:hidden">
		<Button color="light" text={m.action__back()} icon="west" onclick={() => (open = false)} />
	</div>
	<CarForm
		bind:selectedCar
		isAuthenticated
		saveCarLoading={$saveCarQueryStore?.fetching && !saveCarError}
		{initialStateLoading}
		onSaveCar={(carId) => {
			trackSaveCar(carId, selectedCar);
			saveCar(carId);
		}}
		{userCarId}
		class="p-2 md:p-0"
	/>
</ModalDialog>
